module.exports = __webpack_public_path__ + "img/Support-skill-527.80eaf61d.png";